import qs from 'qs';
import {IApiClientInput, IFetchResponse} from '../types';

const sendWithFetch = ({url, data}: IApiClientInput) => {
  return fetch(url, {
    body: JSON.stringify(data),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json() as Promise<IFetchResponse>)
    .then(json => {
      return json.data.trackEvent.success;
    });
};

const sendWithBeacon = ({url, data}: IApiClientInput) => {
  // Navigator has to be bound to ensure it does not error in some browsers
  // https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
  const sendBeacon = navigator.sendBeacon.bind(navigator);
  const body = new Blob([qs.stringify(data)], {
    // This content type is necessary for `sendBeacon`:
    type: 'application/x-www-form-urlencoded',
  });
  return Promise.resolve().then(() => {
    try {
      return sendBeacon(url, body);
    } catch (error) {
      console.error(
        'Encounted error %o when sending tracking request, payload size: %o',
        error,
        body.size
      );
      return false;
    }
  });
};

const sendEvent = (
  requestInformation: IApiClientInput,
  {ssr}: {ssr: boolean}
): Promise<boolean> => {
  const isCompatibleBrowserEnvironment = Boolean(
    !ssr && typeof navigator !== 'undefined' && navigator.sendBeacon
  );

  return isCompatibleBrowserEnvironment
    ? sendWithBeacon(requestInformation)
    : sendWithFetch(requestInformation);
};

export default sendEvent;
